import currency from "currency.js"

export function CurrencyFormat(val) {
  return currency(val, {
    symbol: "",
    decimal: ".",
    separator: ",",
    useVedic: true,
    precision: 2
  }).format()
}

export function DateTimeFormat(val) {
  if (val) {
    return val.replace(/T/g, " ")
  } else {
    return val
  }
}

export function JsonFormat(val) {
  return val
}



// WEBPACK FOOTER //
// ./src/filters/index.js